module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('carousel-page', {
    attrs: {
      "type": 2
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "feature-area section-padding2",
    staticStyle: {
      "background-color": "#f7fafd"
    },
    attrs: {
      "id": "quanyufuwu"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "justify-content": "space-between"
    }
  }, _vm._l((_vm.serviceDXList), function(item) {
    return _c('div', {
      staticClass: "col-lg-3"
    }, [_c('div', {
      staticClass: "serviceDX"
    }, [_c('div', {
      staticClass: "serviceDXT"
    }, [_c('img', {
      staticStyle: {
        "width": "40px"
      },
      attrs: {
        "src": item.icon,
        "alt": "联系我们"
      }
    }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('p', {
      staticClass: "serviceDXP"
    }, [_vm._v(_vm._s(item.text))])])])
  }), 0)])]), _vm._v(" "), _c('section', {
    staticClass: "feature-area section-padding2",
    attrs: {
      "id": "badapingtai"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "justify-content": "space-between"
    }
  }, _vm._l((_vm.zcList), function(item) {
    return _c('div', {
      staticClass: "col-lg-4"
    }, [_c('div', {
      staticClass: "serviceZC"
    }, [_c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": item.img,
        "alt": item.alt
      }
    })])])
  }), 0)])]), _vm._v(" "), _c('section', {
    staticClass: "feature-area section-padding2",
    staticStyle: {
      "background-image": "url(static/assets/images/service/bg.png)",
      "background-size": "100% 100%"
    },
    attrs: {
      "id": "benditese"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(3), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "TbutBgWarp"
  }, [_c('div', {
    staticClass: "TbutBg"
  }, [_c('div', {
    class: _vm.cutCard == 1 ? "Tbut1" : "Tbut",
    on: {
      "click": function($event) {
        _vm.cutCard = 1
      }
    }
  }, [_vm._v("旅游年卡")]), _vm._v(" "), _c('div', {
    class: _vm.cutCard == 2 ? "Tbut1" : "Tbut",
    on: {
      "click": function($event) {
        _vm.cutCard = 2
      }
    }
  }, [_vm._v("旅游专线")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-2 flexcc"
  }, [_c('img', {
    staticClass: "butImg",
    attrs: {
      "src": _vm.cutCard == 1 ? 'static/assets/images/service/l1.png' : 'static/assets/images/service/l2.png',
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.cutCard = 1
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cutCard == 1),
      expression: "cutCard == 1"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "static/assets/images/service/ts1.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cutCard == 2),
      expression: "cutCard == 2"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "static/assets/images/service/ts2.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2 flexcc"
  }, [_c('img', {
    staticClass: "butImg",
    attrs: {
      "src": _vm.cutCard == 2 ? 'static/assets/images/service/r1.png' : 'static/assets/images/service/r2.png',
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.cutCard = 2
      }
    }
  })])])])])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('section', {
    staticClass: "feature-area section-padding2",
    staticStyle: {
      "overflow": "hidden",
      "background-image": "url(\"../static/assets/images/service/bg.png\")",
      "background-size": "100% 100%"
    },
    attrs: {
      "id": "duoqudao"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "justify-content": "space-between"
    }
  }, _vm._l((_vm.zdList), function(item) {
    return _c('div', {
      staticClass: "col-lg-4"
    }, [_c('div', {
      staticClass: "serviceZC"
    }, [_c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": item.img,
        "alt": item.alt
      }
    }), _vm._v(" "), _c('h4', {
      staticClass: "mt20"
    }, [_vm._v(_vm._s(item.alt))])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "SbgWarp"
  }, [_c('div', {
    staticClass: "bgtextTitle"
  }, [_vm._v("全域旅游服务商")]), _vm._v(" "), _c('div', {
    staticClass: "fbgTextWarp"
  }, [_c('div', {
    class: _vm.cutFbgTextIndex == 0 ? "cutFbgTextItem" : "fbgTextItem",
    on: {
      "click": function($event) {
        return _vm.cutIndex(0)
      }
    }
  }, [_vm._v("全域旅游生活服务平台")]), _vm._v(" "), _c('div', {
    class: _vm.cutFbgTextIndex == 1 ? "cutFbgTextItem" : "fbgTextItem",
    on: {
      "click": function($event) {
        return _vm.cutIndex(1)
      }
    }
  }, [_vm._v("全域服务对象")]), _vm._v(" "), _c('div', {
    class: _vm.cutFbgTextIndex == 2 ? "cutFbgTextItem" : "fbgTextItem",
    on: {
      "click": function($event) {
        return _vm.cutIndex(2)
      }
    }
  }, [_vm._v("八大平台支撑")]), _vm._v(" "), _c('div', {
    class: _vm.cutFbgTextIndex == 3 ? "cutFbgTextItem" : "fbgTextItem",
    on: {
      "click": function($event) {
        return _vm.cutIndex(3)
      }
    }
  }, [_vm._v("本地化特色产品打造")]), _vm._v(" "), _c('div', {
    class: _vm.cutFbgTextIndex == 4 ? "cutFbgTextItem" : "fbgTextItem",
    on: {
      "click": function($event) {
        return _vm.cutIndex(4)
      }
    }
  }, [_vm._v("全域分销一站式链条")]), _vm._v(" "), _c('div', {
    class: _vm.cutFbgTextIndex == 5 ? "cutFbgTextItem" : "fbgTextItem",
    on: {
      "click": function($event) {
        return _vm.cutIndex(5)
      }
    }
  }, [_vm._v("多渠道验证终端服务")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "feature-area section-padding2",
    attrs: {
      "id": "quanyulvyou"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row flexJCenter"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {}, [_c('h3', {
    staticClass: "title borderABC"
  }, [_vm._v("全域旅游生活服务平台")]), _vm._v(" "), _c('p', {
    staticClass: "titleShadow"
  }, [_vm._v("GLOBAL TOURISM LIFE SERVICE PLATFORM")])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('p', [_vm._v("\n              实现本地化运营，搭建本地数字化运营平台、营销云平台、分销云平台、文旅大数据指挥云平台、车辆监管平台、年卡运营平台、景区票务平台、政府产业监管平台等八大平台版块。依托于数字化平台为安阳市打造全域文旅智慧解决方案（安阳文旅公共服务中心），并集合本地资源推出相关产品线上数字化运营。\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "mb-3"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "static/assets/images/service/01.png",
      "alt": "企业介绍"
    }
  })])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "section-top text-center"
  }, [_c('h2', {
    staticClass: "title borderBCD"
  }, [_vm._v("全域服务对象")]), _vm._v(" "), _c('p', {
    staticClass: "titleShadow"
  }, [_vm._v("GLOBAL SERVICE OBJECT")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "section-top text-center"
  }, [_c('h2', {
    staticClass: "title borderBCD"
  }, [_vm._v("八大平台支撑")]), _vm._v(" "), _c('p', {
    staticClass: "titleShadow"
  }, [_vm._v("EIGHT PLATFORM SUPPORT")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "section-top text-center"
  }, [_c('h2', {
    staticClass: "title borderBCD"
  }, [_vm._v("本地化特色产品打造")]), _vm._v(" "), _c('p', {
    staticClass: "titleShadow"
  }, [_vm._v("LOCAL FEATURE PRODUCT CREATION")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "feature-area section-padding2",
    attrs: {
      "id": "quanyufenxiao"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "section-top text-center"
  }, [_c('h2', {
    staticClass: "title borderBCD"
  }, [_vm._v("全域分销一站式链条")]), _vm._v(" "), _c('p', {
    staticClass: "titleShadow"
  }, [_vm._v("GLOBAL DISTEIBUTION ONE-STOP CHAIN")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "static/assets/images/service/12.png",
      "alt": "联系我们"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "section-top text-center"
  }, [_c('h2', {
    staticClass: "title borderBCD"
  }, [_vm._v("多渠道验证终端服务")]), _vm._v(" "), _c('p', {
    staticClass: "titleShadow"
  }, [_vm._v("MULTI-CHANNEL VERIFCATION TERMINAL SERVIES")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25d0c2cd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Service.vue
// module id = 97
// module chunks = 1